import { dockMessagesVi } from "./dock.messages.vi";
import { pricePaneMessagesVi } from "./pricePane.messages.vi";
import { tradingMessagesVi } from "./trading.messages.vi";
import { a11yMessagesVi } from "./a11y.messages.vi";
import { licensingMessagesVi } from "./messages.licensing";
import { capabilityMessagesVi } from "./capability.messages.vi";
import { settingsMessagesVi } from "./settings.messages.vi";
import { strategyMessagesVi } from "./strategy.messages.vi";
export const widgetMessagesVi = {
    "widget.loading": "Đang tải biểu đồ…",
    "widget.noData": "Chưa có dữ liệu",
    "widget.error": "Đã xảy ra lỗi trong biểu đồ",
    "widget.title": "Biểu đồ VNStock",
    "widget.symbol": "Mã",
    "widget.timeframe": "Khung thời gian",
    "common.close": "Đóng",
    "drawing.contextMenuTitle": "Tác vụ đối tượng",
    "drawing.copy": "Sao chép",
    "drawing.paste": "Dán",
    "drawing.bringToFront": "Đưa lên trước",
    "drawing.sendToBack": "Đưa xuống sau",
    "drawing.bringForward": "Đưa lên trước",
    "drawing.sendBackward": "Đưa xuống sau",
    "drawing.duplicate": "Nhân bản",
    "drawing.selectGroup": "Chọn nhóm",
    "drawing.deleteGroup": "Xóa nhóm",
    "drawing.syncConflictTitle": "Xung đột bản vẽ",
    "drawing.syncConflictRemoteWon": "Bản vẽ mới hơn từ chart khác đã được áp dụng",
    "drawing.syncConflictDismiss": "Đã hiểu",
    "measurement.title": "Đo lường",
    "measurement.bars": "Số nến",
    "measurement.price": "Δ giá",
    // Tape Panel (O-01)
    "tape.title": "Tape",
    "tape.close": "Đóng",
    "tape.filterLabel": "Lọc theo giá trị",
    "tape.colTime": "Giờ",
    "tape.colPrice": "Giá",
    "tape.colVolume": "KL",
    "tape.colValue": "GT",
    "tape.loading": "Đang tải...",
    "tape.empty": "Chưa có dữ liệu",
    "tape.all": "Tất cả",
    "tape.orderCount": "lệnh",
    "tape.billions": "tỷ",
    "tape.sideBuy": "M",
    "tape.sideSell": "B",
    "tape.sideUnknown": "?",
    // Advisory Panel (I-01)
    "advisory.title": "Khuyến nghị AI",
    "advisory.close": "Đóng",
    "advisory.refresh": "Làm mới phân tích",
    "advisory.decision.STRONG_BUY": "MUA MẠNH",
    "advisory.decision.BUY": "MUA",
    "advisory.decision.HOLD": "GIỮ",
    "advisory.decision.SELL": "BÁN",
    "advisory.decision.STRONG_SELL": "BÁN MẠNH",
    "advisory.confidence": "Tin cậy",
    "advisory.agent.whale": "Cá Mập (Whale)",
    "advisory.agent.tech": "Kỹ Thuật (Tech)",
    "advisory.agent.risk": "Rủi Ro (Risk)",
    "advisory.agent.sentiment": "Tâm Lý (Sentiment)",
    "advisory.expand": "Xem giải thích",
    "advisory.collapse": "Thu gọn",
    "advisory.showSummary": "▼ Xem tóm tắt AI",
    "advisory.hideSummary": "▲ Ẩn tóm tắt",
    "advisory.empty": "Nhấn ↻ để lấy khuyến nghị AI",
    "advisory.action": "Hành động",
    "advisory.risk": "Rủi ro",
    "advisory.score": "Điểm",
    "advisory.components": "Thành phần phân tích",
    "advisory.queued": "Đang tạo phân tích…",
    "advisory.provider": "Nguồn",
    // ── Indicator labels (CE15 + CE16) ──────────────────────────────────
    "indicator.ma": "Đường trung bình động",
    "indicator.candlestick": "Nến Nhật",
    "indicator.hollowCandle": "Nến rỗng",
    "indicator.ohlc": "Thanh OHLC",
    "indicator.heikinAshi": "Heikin-Ashi",
    "indicator.line": "Đường",
    "indicator.area": "Vùng",
    "indicator.bar": "Cột",
    "indicator.ema": "Đường trung bình động lũy thừa",
    "indicator.bollingerBand": "Dải Bollinger",
    "indicator.volume": "Khối lượng",
    "indicator.histogram": "Biểu đồ cột",
    "indicator.whale": "Dòng tiền cá voi",
    "indicator.cvdApprox": "CVD xấp xỉ",
    "indicator.cvdRealtime": "CVD thời gian thực",
    "indicator.rsi": "Chỉ số sức mạnh tương đối",
    "indicator.macd": "Hội tụ/Phân kỳ trung bình động",
    "indicator.strengthElder": "Chỉ báo sức mạnh Elder",
    "indicator.bbi": "Chỉ số Bò và Gấu",
    "indicator.sar": "Parabolic SAR",
    "indicator.obv": "Khối lượng cân bằng",
    "indicator.wr": "Williams %R",
    "indicator.vr": "Tỷ lệ khối lượng",
    "indicator.kdj": "Dao động ngẫu nhiên KDJ",
    "indicator.cci": "Chỉ số kênh hàng hóa",
    "indicator.dmi": "Chỉ số chuyển động định hướng",
    "indicator.bias": "Tỷ lệ lệch",
    "indicator.brar": "Tỷ lệ Bò-Gấu",
    "indicator.mtm": "Đà tăng/giảm",
    "indicator.emv": "Dễ chuyển động",
    "indicator.ao": "Bộ dao động tuyệt vời",
    "indicator.roc": "Tỷ lệ thay đổi",
    "indicator.trix": "MA lũy thừa ba",
    "indicator.dma": "MA vi sai",
    "indicator.pvt": "Xu hướng Giá-Khối lượng",
    "indicator.psy": "Đường tâm lý",
    "indicator.cr": "Chỉ số CR",
    "indicator.strengthRelative": "Sức mạnh tương đối (RS)",
    "indicator.smfi": "Chỉ số Dòng tiền Thông minh",
    "indicator.wyckoffWave": "Sóng Wyckoff",
    "indicator.wma": "Đường trung bình động trọng số",
    "indicator.vwma": "Đường trung bình động trọng số khối lượng",
    "indicator.hma": "Đường trung bình động Hull",
    "indicator.dema": "Đường trung bình động lũy thừa kép",
    "indicator.tema": "Đường trung bình động lũy thừa ba",
    "indicator.maRibbon": "Dải trung bình động",
    "indicator.ichimoku": "Mây Ichimoku",
    "indicator.supertrend": "Supertrend",
    "indicator.keltner": "Kênh Keltner",
    "indicator.donchian": "Kênh Donchian",
    "indicator.chaikinVol": "Biến động Chaikin",
    "indicator.stdDev": "Độ lệch chuẩn",
    "indicator.hv": "Biến động lịch sử",
    "indicator.ci": "Chỉ số biến động",
    "indicator.cmf": "Chaikin Money Flow", "indicator.chaikinOscillator": "Dao động Chaikin", "indicator.chaikinOscillator.description": "Động lượng dòng tiền: EMA nhanh của CMF trừ EMA chậm, cho biết dòng tiền đang mạnh lên hay yếu đi.",
    "indicator.mfi": "Money Flow Index",
    "indicator.volOsc": "Volume Oscillator",
    "indicator.vwap": "Session VWAP",
    "indicator.anchoredVwap": "Anchored VWAP",
    "indicator.alligator": "William Alligator",
    "indicator.fractals": "Fractals",
    "indicator.gator": "Gator Oscillator",
    "indicator.ac": "Accelerator Oscillator",
    "indicator.pivotStandard": "Pivot Points Standard",
    "indicator.pivotHighLow": "Pivot Points High/Low",
    "indicator.marketProfile": "Hồ sơ thị trường (TPO)",
    "indicator.volumeProfile": "Hồ sơ khối lượng",
    "indicator.footprint": "Biểu đồ Footprint",
    "indicator.deltaProfile": "Hồ sơ Delta tích lũy",
    // ── Settings labels ──── (W1.2/A2: `settings.baseAt` là ngưỡng so dấu của histogram series)
    "settings.period": "Chu kỳ",
    "settings.baseAt": "Mốc so sánh",
    "settings.fillMode": "Tô màu",
    "settings.fillMode.none": "Không tô",
    "settings.fillMode.solid": "Màu đặc",
    "settings.fillMode.fade": "Chuyển màu",
    "settings.fillOpacity": "Độ mờ tô",
    "settings.fillColor": "Màu tô",
    "settings.compareSymbol": "Mã đối chiếu",
    "settings.thresholdPercent": "Tỷ lệ ngưỡng %",
    "settings.stdDev": "Độ lệch chuẩn",
    "settings.fast": "Nhanh",
    "settings.slow": "Chậm",
    "settings.signal": "Tín hiệu",
    "settings.thresholdUsd": "Ngưỡng USD",
    "settings.afStep": "Bước tăng AF",
    "settings.afMax": "AF tối đa",
    "settings.signalPeriod": "Chu kỳ tín hiệu",
    "settings.fastPeriod": "Chu kỳ nhanh",
    "settings.slowPeriod": "Chu kỳ chậm",
    "settings.m1": "M1",
    "settings.m2": "M2",
    "settings.m3": "M3",
    "settings.m4": "M4",
    "settings.remove": "Xóa",
    "settings.deletePane": "Xóa pane",
    "settings.paneName": "Tên khung",
    "settings.addIndicator": "Thêm chỉ báo",
    "settings.indicatorType": "Loại",
    "settings.layout": "Bố cục",
    "settings.indicators": "Chỉ báo",
    "settings.theme": "Giao diện",
    "settings.reset": "Đặt lại",
    "settings.licensing": "Bản quyền",
    "licensing.title": "Cấu hình Bản quyền & Cấp phép",
    "licensing.desc": "Nhập khóa Personal Access Token (PAT) thủ công để khôi phục hoặc nâng cấp dịch vụ đồ thị khi khóa mặc định hết hạn.",
    "licensing.inputLabel": "Khóa Personal Access Token (PAT)",
    "licensing.save": "Cập nhật khóa",
    "licensing.clear": "Khôi phục mặc định",
    "licensing.statusActive": "Đang hoạt động",
    "licensing.statusExpired": "Đã hết hạn hoặc không hợp lệ",
    "licensing.statusSuspended": "Bị đình chỉ",
    "licensing.plan": "Gói cước hiện tại",
    "licensing.status": "Trạng thái kết nối",
    "licensing.domainWhitelist": "Danh sách Domain hợp lệ",
    "licensing.tenant": "Đơn vị sở hữu (Tenant)",
    "licensing.patPlaceholder": "Dán key vni_... tại đây...",
    "licensing.successUpdate": "Cập nhật khóa bản quyền thành công!",
    "licensing.successClear": "Đã khôi phục cấu hình bản quyền mặc định.",
    "licensing.offlineActivated": "Đã kích hoạt {tier} offline (hết hạn {date}).",
    "licensing.offlineInvalid": "Key ký số không hợp lệ hoặc đã hết hạn.",
    "licensing.legacySaved": "Đã lưu key. Key định dạng cũ — cần server xác thực; offline cần key ký số vni1.* để mở Pro.",
    "licensing.legacyHint": "Key đang lưu là định dạng cũ, không tự mở Pro khi offline.",
    "settings.timezone": "Múi giờ hệ thống",
    "settings.open": "Cài đặt",
    "settings.resetDefaults": "Khôi phục mặc định",
    "settings.resetLayout": "Đặt lại bố cục",
    "settings.overlayTimeframe": "Khung thời gian phủ",
    "settings.overlayStyle": "Kiểu phủ",
    "settings.overlayNone": "Không",
    "settings.styleCandle": "Nến",
    "settings.styleHollowBox": "Hộp rỗng",
    "settings.styleStepLine": "Đường bậc thang",
    "settings.styleArea": "Vùng",
    "settings.workspaceJson": "Nhập/Xuất tệp cấu hình Bố cục",
    "settings.workspaceJsonNote": "Xuất hoặc nhập toàn bộ bố cục làm việc của bạn bao gồm các phân vùng, hình vẽ và cài đặt.",
    "settings.exportWorkspace": "Xuất bố cục",
    "settings.importWorkspace": "Nhập bố cục",
    "settings.importSuccess": "Nhập cấu hình bố cục thành công!",
    "settings.sub.rsiLine": "Đường RSI",
    "settings.sub.rsiOverbought": "Quá mua (70)",
    "settings.sub.rsiMiddle": "Giữa (50)",
    "settings.sub.rsiOversold": "Quá bán (30)",
    "settings.sub.macd": "Đường MACD",
    "settings.sub.signal": "Đường Signal",
    "settings.sub.diverge": "Histogram",
    "settings.sub.bbMiddle": "Đường giữa",
    "settings.sub.bbUpper": "Dải trên",
    "settings.sub.bbLower": "Dải dưới",
    "settings.sub.k": "Đường K",
    "settings.sub.d": "Đường D",
    "settings.sub.j": "Đường J",
    "settings.sub.plusDI": "+DI",
    "settings.sub.minusDI": "-DI",
    "settings.sub.adx": "ADX",
    "settings.sub.ar": "AR",
    "settings.sub.br": "BR",
    "settings.sub.bull": "Bull Power",
    "settings.sub.bear": "Bear Power",
    "settings.sub.mtm": "MTM",
    "settings.sub.emv": "EMV",
    "settings.sub.trix": "TRIX",
    "settings.sub.ddd": "DDD",
    "settings.sub.ama": "AMA",
    "settings.sub.psy": "PSY",
    "settings.sub.cr": "CR",
    "settings.sub.ma1": "MA1",
    "settings.sub.ma2": "MA2",
    "settings.sub.ma3": "MA3",
    "settings.sub.ma4": "MA4",
    // ── Drawing tools ──────────────────────────────────────────────────
    "tool.trendLine": "Đoạn thẳng",
    "tool.hLine": "Đường ngang",
    "tool.vLine": "Đường dọc",
    "tool.ray": "Tia",
    "tool.extendedLine": "Đường thẳng",
    "tool.fibonacci": "Fibonacci",
    "tool.channel": "Kênh giá",
    "tool.text": "Ghi chú",
    "tool.rectangle": "Hình chữ nhật",
    "tool.circle": "Hình tròn",
    "tool.ellipse": "Ellipse",
    "tool.triangle": "Tam giác",
    "tool.arrow": "Mũi tên",
    "tool.polyline": "Đa tuyến",
    "tool.callout": "Chú thích",
    "tool.priceLabel": "Nhãn giá",
    "tool.priceRange": "Dải giá",
    "tool.dateRange": "Khoảng thời gian",
    "tool.barsCount": "Đếm nến",
    "tool.fibChannel": "Kênh Fibonacci",
    "tool.fibSpeedResistanceFan": "Quạt Fib Tốc độ/Kháng cự",
    "tool.trendBasedFibTime": "Fib Time theo Xu hướng",
    "tool.fibCircles": "Vòng tròn Fibonacci",
    "tool.fibSpiral": "Xoắn ốc Fibonacci",
    "tool.fibSpeedResistanceArcs": "Cung Fib Tốc độ/Kháng cự",
    "tool.fibWedge": "Nêm Fibonacci",
    "tool.pitchfan": "Pitchfan",
    "tool.gannFan": "Quạt Gann",
    "tool.gannBox": "Hộp Gann",
    "tool.gannSquare": "Vuông Gann",
    "tool.gannSquareFixed": "Vuông Gann Cố định",
    "tool.cyclicLines": "Đường Chu kỳ",
    "tool.timeCycles": "Chu kỳ Thời gian",
    "tool.sineLine": "Đường Sin",
    "tool.xabcdPattern": "Mô hình XABCD",
    "tool.cypherPattern": "Mô hình Cypher",
    "tool.headAndShoulders": "Đầu và Vai",
    "tool.trianglePattern": "Mô hình Tam giác",
    "tool.threeDrivesPattern": "Ba Sóng Đẩy",
    "tool.elliottImpulse": "Elliott Xung Lực",
    "tool.elliottCorrection": "Elliott Điều Chỉnh",
    "tool.elliottTriangle": "Elliott Tam Giác",
    "tool.elliottDoubleCombo": "Elliott Kết Hợp Đôi",
    "tool.elliottTripleCombo": "Elliott Kết Hợp Ba",
    "tool.fibExtension": "Fib Mở rộng",
    "tool.parallelChannel": "Kênh Song song",
    "tool.pitchfork": "Andrew's Pitchfork",
    "tool.abcdPattern": "Mô hình ABCD",
    "tool.fibArc": "Cung Fibonacci",
    "tool.fibTimeZone": "Múi giờ Fibonacci",
    "tool.regressionChannel": "Kênh Hồi quy",
    "tool.cursor": "Con trỏ",
    "tool.crosshair": "Crosshair",
    "tool.longPosition": "Vị thế Long",
    "tool.shortPosition": "Vị thế Short",
    "tool.dateAndPriceRange": "Khoảng Giá & Thời gian",
    // CE22: Drawing Tools Pack 1
    "tool.disjointChannel": "Kênh rời rạc",
    "tool.flatTopBottom": "Đỉnh/Đáy phẳng",
    "tool.schiffPitchfork": "Schiff Pitchfork",
    "tool.modifiedSchiff": "Modified Schiff",
    "tool.insidePitchfork": "Inside Pitchfork",
    "tool.gannFixed": "Gann Fixed",
    "tool.trendAngle": "Góc trend",
    "tool.infoLine": "Đường thông tin",
    // CE23: Drawing Tools Pack 2
    "tool.brush": "Cọ vẽ",
    "tool.highlighter": "Bút highlight",
    "tool.eraser": "Cục tẩy",
    "tool.curve": "Đường cong",
    "tool.arc": "Cung tròn",
    "tool.path": "Đường path",
    "tool.polygon": "Đa giác",
    "tool.rotatedRectangle": "HCN xoay",
    "tool.brush.description": "Vẽ tự do bằng nét cọ",
    "tool.highlighter.description": "Highlight bán trong suốt",
    "tool.eraser.description": "Xóa nét vẽ tự do",
    "tool.curve.description": "Đường cong Bezier qua 3 điểm",
    "tool.arc.description": "Cung tròn qua 3 điểm",
    "tool.path.description": "Đường nhiều điểm, double-click để kết thúc",
    "tool.polygon.description": "Đa giác kín có fill",
    "tool.rotatedRectangle.description": "Hình chữ nhật xoay tự do",
    // CE24: Drawing Tools Pack 3
    "tool.anchoredVwap": "VWAP neo",
    "tool.iconMarker": "Icon/Emoji",
    "tool.ghostFeed": "Ghost Feed",
    "tool.barsPattern": "Mô hình nến",
    "tool.crossLine": "Cross Line",
    "tool.datePriceRange": "Khoảng ngày/giá",
    "tool.anchoredVwap.description": "VWAP tính từ điểm neo tùy chọn",
    "tool.iconMarker.description": "Đặt icon hoặc emoji lên chart",
    "tool.ghostFeed.description": "Overlay biểu đồ từ symbol/timeframe khác",
    "tool.barsPattern.description": "Tìm mô hình nến tương tự",
    "tool.crossLine.description": "Hai đường cắt nhau hiển thị price/time",
    "tool.datePriceRange.description": "Đo khoảng cách: % giá, bars, ngày, R:R, góc",
    "tool.group.cursor": "Con trỏ",
    "tool.group.lines": "Đường kẻ",
    "tool.group.channels": "Kênh giá",
    "tool.group.fibonacci": "Fibonacci",
    "tool.group.gann": "Gann",
    "tool.group.pitchfork": "Pitchfork",
    "tool.group.shapes": "Hình dạng",
    "tool.group.measurement": "Đo lường",
    "tool.group.patterns": "Mô hình",
    "tool.group.elliott": "Sóng Elliott",
    "tool.group.cycles": "Chu kỳ",
    "tool.group.annotation": "Chú thích",
    "tool.group.orderflow": "Order Flow",
    "tool.group.icons": "Icons",
    "tool.group.advancedLines": "Đường nâng cao",
    "tool.group.drawing": "Vẽ tự do",
    // ── Drawing UI ─────────────────────────────────────────────────────
    "drawing.stroke": "Nét",
    "drawing.selectIcon": "Chọn Icon",
    "drawing.iconSize": "Cỡ Icon",
    "drawing.fill": "Tô",
    "drawing.strokeWidth": "Độ dày nét",
    "drawing.lineStyle": "Kiểu nét",
    "drawing.opacity": "Độ mờ",
    "drawing.solid": "Liền",
    "drawing.dashed": "Đứt đoạn",
    "drawing.dotted": "Chấm",
    "drawing.lock": "Khóa",
    "drawing.unlock": "Mở khóa",
    "drawing.clone": "Nhân bản",
    "drawing.hide": "Ẩn",
    "drawing.show": "Hiện",
    "drawing.openProperties": "Chi tiết",
    "drawing.delete": "Xóa",
    "drawing.close": "Đóng",
    "drawing.hideToolbar": "Ẩn thanh công cụ",
    "drawing.showToolbar": "Hiện thanh công cụ",
    "drawing.handle.delete": "Xóa",
    "drawing.handle.clone": "Nhân bản",
    "drawing.handle.lock": "Khóa",
    "drawing.handle.unlock": "Mở khóa",
    "drawing.drawingsList": "Danh sách nét vẽ",
    "drawing.drawingsListEmpty": "Chưa có nét vẽ nào.",
    "drawing.visible": "Hiện",
    "drawing.hidden": "Ẩn",
    "drawing.locked": "Khóa",
    "drawing.unlocked": "Mở khóa",
    "drawing.dockTitle": "Dock nét vẽ",
    "drawing.dockProperties": "Thuộc tính",
    "drawing.dockObjects": "Đối tượng",
    "drawing.dockTemplates": "Mẫu",
    "drawing.dockPropertiesEmpty": "Chọn một nét vẽ để chỉnh sửa thuộc tính.",
    "drawing.dockObjectsEmpty": "Chưa có nét vẽ nào.",
    "drawing.dockTemplatesEmpty": "Tab mẫu sẽ được hoàn thiện sau.",
    "drawing.dock.toggle": "Dock nét vẽ",
    "drawing.dock.toggleShortcut": "Ctrl+Shift+L",
    "drawing.dock.resize": "Thay đổi kích thước",
    "drawing.dock.title": "Quản lý bản vẽ",
    "drawing.dock.close": "Đóng",
    "drawing.dock.properties": "Thuộc tính",
    "drawing.dock.objects": "Đối tượng",
    "drawing.dock.templates": "Mẫu",
    "drawing.dock.emptyProperties": "Chưa chọn đối tượng",
    "drawing.dock.emptyObjects": "Chưa có bản vẽ nào",
    "drawing.dock.emptyTemplates": "Chưa có mẫu nào",
    "drawing.rename": "Đổi tên",
    "drawing.saveFailed": "Không lưu được bản vẽ (đầy bộ nhớ)",
    "drawing.importFailed": "Không đọc được file bản vẽ",
    "drawing.edit": "Sửa",
    "drawing.properties": "Thuộc tính",
    "drawing.searchPlaceholder": "Tìm bản vẽ…",
    "drawing.list.title": "Bản vẽ hiện tại",
    "drawing.list.empty": "Không có bản vẽ",
    "drawing.list.visible": "Hiện",
    "drawing.list.hidden": "Ẩn",
    "drawing.list.locked": "Khóa",
    "drawing.list.unlocked": "Mở khóa",
    "drawing.list.selected": "Đang chọn",
    "drawing.list.delete": "Xóa",
    "drawing.toolbar.deleteAll": "Xóa tất cả",
    "drawing.toolbar.lockAll": "Khóa tất cả",
    "drawing.toolbar.unlockAll": "Mở khóa tất cả",
    "drawing.toolbar.hideAll": "Ẩn tất cả",
    "drawing.toolbar.showAll": "Hiện tất cả",
    "drawing.toolbar.batchColor": "Đổi màu tất cả",
    "drawing.toolbar.selectedCount": "Đã chọn {count}",
    "drawing.toolbar.dragHint": "Kéo để di chuyển thanh công cụ",
    "drawing.toolbar.all": "Tất cả",
    "drawing.toolbar.pickColor": "Chọn màu sắc",
    "drawing.toolbar.strokeWidth": "Độ dày nét",
    "drawing.toolbar.lineStyle": "Kiểu nét vẽ",
    "drawing.toolbar.solid": "Liền",
    "drawing.toolbar.dashed": "Đứt đoạn",
    "drawing.toolbar.dotted": "Chấm",
    "drawing.toolbar.point": "Điểm",
    "drawing.resourcesSuspended": "Tài nguyên biểu đồ bị tạm dừng ({reason})",
    "drawing.selection.duplicate": "Nhân bản",
    "drawing.selection.group": "Gom nhóm",
    "tool.premiumLocked": "Nâng cấp Pro",
    "toolbar.favoriteTools": "Yêu thích",
    "drawing.pointLegendTitle": "Điểm thành phần",
    "drawing.pointLegendEmpty": "Chọn một nét vẽ có điểm semantic.",
    "drawing.pointLegendClear": "Xóa focus",
    "drawing.inspectorTitle": "Bảng điều khiển nét vẽ",
    "drawing.inspector.saveStyle": "Lưu làm mặc định",
    "drawing.inspector.rrTitle": "Vào lệnh",
    "drawing.inspector.rrEntry": "Entry",
    "drawing.inspector.rrStop": "Stop",
    "drawing.inspector.rrTarget": "Target",
    "drawing.inspector.segmentsTitle": "Thành phần",
    "drawing.coordinatesTitle": "Tọa độ",
    "drawing.priceLabel": "Mức giá",
    "drawing.text.bold": "Đậm",
    "drawing.text.italic": "Nghiêng",
    "drawing.text.alignLeft": "Căn trái",
    "drawing.text.alignCenter": "Căn giữa",
    "drawing.text.alignRight": "Căn phải",
    "drawing.text.background": "Nền",
    "drawing.text.border": "Viền",
    "drawing.text.radius": "Bo góc",
    "drawing.text.shadow": "Đổ bóng",
    "drawing.callout.tail": "Đuôi",
    "drawing.priceLabel.anchored": "Neo trục",
    "drawing.icon.search": "Tìm icon…",
    "drawing.icon.recent": "Gần đây",
    "drawing.icon.custom": "URL tùy chỉnh",
    "drawing.timeLabel": "Thời gian",
    "drawing.templatesTitle": "Mẫu",
    "drawing.templatesSave": "Lưu Mẫu",
    "drawing.templatesDelete": "Xóa Mẫu",
    "drawing.templatesLoad": "Tải Mẫu",
    "drawing.templatesNamePlaceholder": "Tên mẫu mới...",
    "drawing.fibLevelsTitle": "Các Mức Fibonacci",
    "drawing.fibAddLevel": "Thêm mức",
    "drawing.fibRemoveLevel": "Xóa",
    "drawing.toggleList": "Danh sách nét vẽ",
    "drawing.textEditorTitle": "Chỉnh sửa văn bản",
    "drawing.textEditorLabel": "Nội dung",
    "drawing.textEditorPlaceholder": "Nhập nội dung văn bản",
    "drawing.textEditorEdit": "Sửa văn bản",
    "drawing.textEditorSave": "Lưu",
    "drawing.textEditorCancel": "Hủy",
    "drawing.textEditorEmpty": "Chưa có nội dung",
    "drawing.magnetSensitivity": "Độ nhạy nam châm",
    "drawing.magnet.weak": "Yếu",
    "drawing.magnet.normal": "Bình thường",
    "drawing.magnet.strong": "Mạnh",
    "drawing.magnet.off": "Tắt",
    "drawing.lineType.label": "Loại đường",
    "drawing.lineType.trendLine": "Đoạn thẳng",
    "drawing.lineType.ray": "Tia (kéo phải)",
    "drawing.lineType.extendedLine": "Đường thẳng",
    "drawing.gannFan.label": "Quạt Gann",
    "drawing.measure.priceDeltaPrefix": "Δ giá: ",
    "drawing.measure.barsLabel": "nến",
    "drawing.fib.levelsTitle": "Các mức Fibonacci",
    "drawing.fib.addLevel": "Thêm mức",
    "drawing.fib.removeLevel": "Xóa",
    "drawing.elliott.impulse": "Sóng Elliott Xung Lực",
    "drawing.elliott.correction": "Sóng Elliott Điều Chỉnh",
    "drawing.elliott.triangle": "Tam Giác Elliott",
    "drawing.elliott.doubleCombo": "Kết Hợp Đôi Elliott",
    "drawing.elliott.tripleCombo": "Kết Hợp Ba Elliott",
    "drawing.pattern.xabcd": "Mô hình XABCD",
    "drawing.pattern.cypher": "Mô hình Cypher",
    "drawing.pattern.headAndShoulders": "Đầu và Vai",
    "drawing.pattern.triangle": "Mô hình Tam Giác",
    "drawing.pattern.threeDrives": "Ba Đợt Sóng",
    "drawing.pattern.ratioLabel": "Tỉ lệ",
    "drawing.fib.channel": "Kênh Fibonacci",
    "drawing.fib.speedResistanceFan": "Quạt Tốc Độ Fibonacci",
    "drawing.fib.trendBasedFibTime": "Thời Gian Fibonacci Theo Xu Hướng",
    "drawing.fib.circles": "Vòng Tròn Fibonacci",
    "drawing.fib.spiral": "Xoắn Fibonacci",
    "drawing.fib.speedResistanceArcs": "Cung Tốc Độ Fibonacci",
    "drawing.fib.wedge": "Nêm Fibonacci",
    "drawing.fib.pitchfan": "Pitchfan",
    "drawing.gann.box": "Hộp Gann",
    "drawing.gann.squareFixed": "Gann Vuông Cố Định",
    "drawing.gann.square": "Gann Vuông",
    "drawing.cycle.cyclicLines": "Đường Chu Kỳ",
    "drawing.cycle.timeCycles": "Chu Kỳ Thời Gian",
    "drawing.cycle.sineLine": "Đường Sin",
    "drawing.cycle.count": "Số Chu Kỳ",
    "drawing.cycle.amplitude": "Biên Độ",
    "drawing.selected": "Đang chọn",
    "drawing.exportJson": "Xuất JSON",
    "drawing.importJson": "Nhập JSON",
    "drawing.clearAll": "Xóa hết",
    // ── Alert ──────────────────────────────────────────────────────────
    "drawing.alert.title": "🔔 Cảnh báo",
    "drawing.alert.enabled": "Bật",
    "drawing.alert.direction": "Hướng kích hoạt",
    "drawing.alert.cooldown": "Cooldown (giây)",
    "drawing.alert.crossAbove": "Cắt lên",
    "drawing.alert.crossBelow": "Cắt xuống",
    "drawing.alert.either": "Cả hai",
    "alert.crossAbove": "Cắt lên",
    "alert.crossBelow": "Cắt xuống",
    "alert.at": "Tại",
    "alert.dismiss": "Đóng",
    // ── Replay ─────────────────────────────────────────────────────────
    "replay.controls": "Điều khiển phát lại",
    "replay.play": "Phát",
    "replay.pause": "Tạm dừng",
    "replay.stop": "Dừng",
    "replay.rewind": "Về đầu",
    "replay.jumpLatest": "Về hiện tại",
    "replay.stepBack": "Lùi 1 nến",
    "replay.stepForward": "Tiến 1 nến",
    "replay.speed": "Tốc độ phát",
    "replay.interval": "Khoảng cách",
    "replay.interval.source": "Bar gốc",
    "replay.interval.1s": "1s",
    "replay.interval.1m": "1 phút",
    "replay.interval.5m": "5 phút",
    "replay.interval.15m": "15 phút",
    "replay.interval.1h": "1 giờ",
    "replay.progress": "{current}/{total} nến",
    "replay.fromHere": "Phát lại từ đây",
    "replay.closeBar": "Đóng phát lại",
    "replay.mode": "Chế độ phát lại",
    "replay.hintClickBar": "Click vào nến: chọn điểm bắt đầu",
    "replay.cutHint": "Click vào nến để bắt đầu phát lại",
    "replay.jumpToBar": "Nhảy tới nến",
    "replay.cutBadge": "Cắt tại {date}",
    "replay.seek": "Tìm nến",
    "replay.speedLabel": "Tốc độ phát",
    "replay.intervalLabel": "Khoảng cách",
    "replay.modeLabel": "Phạm vi phát lại",
    "replay.mode.single": "1 chart",
    "replay.mode.all": "Tất cả charts",
    "replay.toggle": "Phát lại",
    "replay.speedUnit": "x",
    "replay.analyticsTrades": "{count}L",
    "replay.analyticsWinRate": "{rate}%",
    "replay.analyticsProfitFactor": "{pf}HS",
    "replay.analyticsProfitFactorInf": "∞",
    "replay.analyticsDrawdown": "{dd}%DD",
    // ── Header ──────────────────────────────────────────────────────────
    "header.search": "Tìm kiếm",
    "header.settings": "Cài đặt",
    "header.fullscreen": "Toàn màn hình",
    "header.snapshot": "Chụp màn hình", "header.csvExport": "Xuất CSV", "header.csvExportTitle": "Xuất dữ liệu CSV",
    "header.saveTemplate": "Lưu template",
    "header.loadTemplate": "Tải template",
    "header.alerts": "Cảnh báo",
    "header.systemMenu": "Menu hệ thống",
    "header.compare": "So sánh mã",
    "header.chartType": "Chọn loại biểu đồ",
    "header.chartTypeOptions": "Các loại biểu đồ",
    "header.compareTitle": "Công cụ so sánh",
    "header.searchTitle": "Tìm kiếm nhanh",
    "header.settingsTitle": "Cài đặt",
    "header.fullscreenTitle": "Chế độ toàn màn hình",
    "header.snapshotTitle": "Chụp ảnh màn hình",
    "header.saveTemplateTitle": "Lưu layout template",
    "header.loadTemplateTitle": "Tải layout template",
    "header.alertsTitle": "Quản lý cảnh báo",
    "header.systemMenuTitle": "Mở menu hệ thống",
    "header.upgradePro": "Pro",
    "header.timeframe": "Khung thời gian",
    "header.exitFullscreen": "Thu nhỏ",
    // ── Mobile ──────────────────────────────────────────────────────────
    "mobile.systemMenu": "Menu hệ thống",
    "mobile.upgradePro": "Nâng cấp Pro",
    "mobile.searchSymbol": "Tìm kiếm mã",
    // ── Paper Trading ──────────────────────────────────────────────────
    "paperTrading.title": "Giao dịch ảo",
    "paperTrading.hint": "Bấm vào chart khi phát lại đang chạy để mở vị thế ảo.",
    "paperTrading.report": "Báo cáo replay",
    "paperTrading.finalized": "Đã chốt",
    "paperTrading.total": "Tổng lệnh",
    "paperTrading.wins": "Lệnh thắng",
    "paperTrading.losses": "Lệnh thua",
    "paperTrading.winRate": "Tỷ lệ thắng",
    "paperTrading.realized": "PnL đã chốt",
    "paperTrading.avgPnl": "PnL trung bình",
    "paperTrading.unrealized": "PnL đang mở",
    "paperTrading.avgBarsHeld": "Số nến giữ lệnh",
    "paperTrading.bestTrade": "Lệnh tốt nhất",
    "paperTrading.worstTrade": "Lệnh tệ nhất",
    "paperTrading.journal": "Nhật ký giao dịch",
    "paperTrading.barsUnit": "nến",
    "paperTrading.position": "Vị thế",
    "paperTrading.entry": "Mở tại",
    "paperTrading.reset": "Xóa nhật ký",
    "paperTrading.empty": "Chưa có giao dịch ảo nào.",
    "paperTrading.open": "Đang mở",
    "paperTrading.closed": "Đã đóng",
    // ── Toolbar ────────────────────────────────────────────────────────
    "toolbar.candleType": "Loại nến",
    "toolbar.recent": "Công cụ gần đây",
    "toolbar.searchPlaceholder": "Tìm công cụ…",
    "toolbar.searchNoResults": "Không có công cụ phù hợp",
    "toolbar.favorite": "Yêu thích",
    "toolbar.unfavorite": "Bỏ yêu thích",
    "toolbar.hideFavoritesBar": "Ẩn thanh công cụ yêu thích",
    "toolbar.showFavoritesBar": "Hiện thanh công cụ yêu thích",
    "toolbar.toggleFavoritesBar": "Ẩn/Hiện thanh yêu thích",
    "toolbar.unpinFromFavorites": "Bỏ khỏi danh sách yêu thích",
    "toolbar.moreTools": "Công cụ yêu thích",
    "toolbar.utility.zoomIn": "Phóng to",
    "toolbar.utility.zoomOut": "Thu nhỏ",
    "chart.nav.panLeft": "Cuộn trái",
    "chart.nav.panRight": "Cuộn phải",
    "chart.nav.fitToData": "Vừa dữ liệu",
    "chart.nav.toggleSolo": "Xem đơn lẻ",
    "chart.nav.restoreGrid": "Khôi phục lưới",
    "chart.nav.toolbarLabel": "Điều hướng biểu đồ",
    "toolbar.title": "Thanh vẽ",
    "toolbar.dock": "Ghim thanh công cụ",
    "toolbar.undock": "Tháo ghim thanh công cụ",
    "toolbar.drawingTools": "Công cụ vẽ",
    "toolbar.selectChart": "Chọn biểu đồ",
    "toolbar.lock": "Khóa thanh công cụ",
    "toolbar.unlock": "Mở khóa thanh công cụ",
    "toolbar.expand": "Mở rộng",
    "toolbar.collapse": "Thu gọn",
    "toolbar.collapseGroup": "Thu gọn {group}",
    "toolbar.expandGroup": "Mở rộng {group}",
    "toolbar.actions": "Thao tác",
    "toolbar.dangerousActions": "Thao tác xóa",
    // ── Candle/Chart types ─────────────────────────────────────────────
    "candleType.candlestick": "Nến Nhật",
    "candleType.hollow": "Nến rỗng",
    "candleType.ohlc": "Thanh OHLC",
    "candleType.heikinashi": "Heikin-Ashi",
    "candleType.line": "Biểu đồ đường",
    "candleType.area": "Biểu đồ diện tích",
    "chartType.candlestick": "Nến Nhật",
    "chartType.hollow": "Hollow Candle",
    "chartType.ohlc": "OHLC Bar",
    "chartType.heikinashi": "Heikin Ashi",
    "chartType.line": "Đường",
    "chartType.area": "Vùng",
    // ── Library labels ─────────────────────────────────────────────────
    "library.range.1d": "1D",
    "library.range.5d": "5D",
    "library.range.1m": "1M",
    "library.range.3m": "3M",
    "library.range.ytd": "YTD",
    "library.range.1y": "1Y",
    "library.range.all": "All",
    "library.pricePaneLabel": "Price",
    "library.volumePaneLabel": "Volume",
    "library.momentumPaneLabel": "RSI+MACD",
    "library.orderflowPaneLabel": "Order Flow",
    "library.strengthPaneLabel": "Strength",
    "library.genericPaneLabel": "Khung {index}",
    // ── Symbol Search ────────────────────────────────────────────────
    "symbolSearch.placeholder": "Tìm mã chứng khoán...",
    "symbolSearch.switch": "Chuyển mã",
    "whale.title": "Dòng tiền",
    "whale.whale": "Cá voi",
    "whale.shark": "Cá mập",
    "whale.small": "Nhỏ lẻ",
    "whale.buy": "Mua",
    "whale.sell": "Bán",
    "whale.net": "Net",
    "whale.alerts": "Cảnh báo",
    // ── Settings (from demo PaneSettingsModal) ───────────────────────
    "settings.maxVisibleBars": "Số nến hiển thị tối đa",
    "settings.maxVisibleBarsNote": "Giới hạn số nến hiển thị khi thu phóng.",
    "settings.zoomSpeed": "Tốc độ zoom",
    "settings.zoomSpeedNote": "Điều chỉnh tốc độ zoom mỗi bước cuộn (1.05 chậm - 1.3 nhanh).",
    "settings.showNonTradingDays": "Hiển thị ngày không giao dịch",
    "settings.showNonTradingDaysNote": "Hiển thị ngày nghỉ và cuối tuần trên trục X.",
    "settings.datasource": "Nguồn dữ liệu",
    "settings.datasourceTitle": "Cấu hình nguồn dữ liệu",
    "settings.dataAdapter.binance": "Binance",
    "settings.dataAdapter.local": "Dữ liệu offline",
    "settings.headerTitleActive": "Cài đặt biểu đồ — {symbol} · {timeframe}",
    "settings.activeBadge": "Biểu đồ đang chọn",
    "settings.applyToAll": "Áp dụng cho tất cả",
    "settings.applyToAllNote": "Sao chép giao diện & phong cách cho tất cả biểu đồ (giữ nguyên mã, panes và chế độ thang)",
    "settings.applyToAllDone": "Đã áp dụng giao diện cho {count} biểu đồ",
    "settings.applyIndicatorsToAll": "Áp dụng chỉ số cho tất cả biểu đồ",
    // ── Profile / Account ────────────────────────────────────────────
    "profile.menu": "Tài khoản",
    "profile.login": "Đăng nhập",
    "profile.register": "Đăng ký",
    "profile.upgrade": "⭐ Nâng cấp tài khoản",
    "profile.settings": "Cài đặt tài khoản",
    "profile.logout": "Đăng xuất",
    // ── Data Source ──────────────────────────────────────────────────
    "dataSource.label": "Nguồn dữ liệu",
    "dataSource.demo": "Offline",
    "dataSource.binanceOnline": "Binance",
    "dataSource.binanceOffline": "Offline",
    "dataSource.vninvest": "VNInvest",
    "dataSource.switch": "Chuyển nguồn",
    // ── Library / Status ─────────────────────────────────────────────
    "library.backfillingHistory": "Đang nạp thêm lịch sử…",
    "library.loadingPriceData": "Đang tải dữ liệu…",
    "library.loadingRealData": "Đang tải dữ liệu thật…",
    "common.liveBinance": "● LIVE · Binance",
    "common.offlineFallback": "⚠ Dự phòng offline",
    "common.loading": "↻ Đang tải…",
    "common.binanceLoading": "Đang tải dữ liệu Binance…",
    "common.binanceLiveLoading": "Đang tải dữ liệu thật từ Binance…",
    "common.canvasInitializing": "Đang khởi tạo canvas…",
    "common.chartInitializing": "Đang khởi tạo khung biểu đồ...",
    "common.compare": "So sánh",
    "compare.existing": "Mã đang so sánh",
    "compare.add": "Thêm",
    "compare.remove": "Bỏ",
    "compare.normalize": "% Thay đổi",
    "compare.absolute": "Giá trị",
    "compare.hide": "Ẩn",
    "compare.show": "Hiện",
    "compare.searchPlaceholder": "Tìm mã chứng khoán...",
    "compare.title": "So sánh mã",
    "compare.currentSymbol": "Hiện tại",
    "compare.peekMode": "Xem nhanh",
    "common.replay": "Phát lại",
    "common.upgrade": "Nâng cấp",
    "common.script": "Kịch bản",
    "common.alert": "Cảnh báo",
    "common.trade": "Giao dịch",
    "common.panes": "Panes",
    "common.bars": "nến",
    "common.source": "Nguồn dữ liệu",
    "common.range": "Khung nhìn",
    "common.status": "Trạng thái",
    // ── Theme ────────────────────────────────────────────────────────
    "theme.light": "Chế độ sáng",
    "theme.dark": "Chế độ tối",
    "theme.switchToLight": "Chuyển sang sáng",
    "theme.switchToDark": "Chuyển sang tối",
    // ── Timezone ─────────────────────────────────────────────────────
    "timezone.hcm": "Việt Nam (ICT - UTC+7)",
    "timezone.utc": "Giờ Quốc tế (UTC)",
    "timezone.ny": "New York (EST/EDT)",
    "timezone.london": "London (GMT/BST)",
    // ── Settings Upgrade ──────────────────────────────────────────────
    "settings.dialogKicker": "Cài đặt",
    "settings.dialogClose": "Đóng hộp thoại cài đặt",
    "settings.layoutKicker": "Bố cục",
    "settings.managePanes": "Quản lý pane",
    "settings.maxVisible": "Số pane hiển thị tối đa",
    "settings.addPane": "+ Thêm pane",
    "settings.hide": "Ẩn",
    "settings.restore": "Khôi phục",
    "settings.indicatorKicker": "Chỉ báo",
    "settings.indicatorEditor": "Biên tập theo khung",
    "settings.visible": "Hiện",
    "settings.yAxis": "Trục Y",
    "settings.yAxisLeft": "Trái",
    "settings.yAxisRight": "Phải",
    "settings.comparison": "Chuẩn so sánh",
    "settings.lineStyle": "Kiểu",
    "settings.lineStyleSolid": "Liền",
    "settings.lineStyleDashed": "Đứt",
    "settings.lineStyleDotted": "Chấm",
    "settings.fillArea": "Tô vùng",
    "settings.normalizeToBaseline": "% Thay đổi",
    "settings.noPane": "Không có khung nào khả dụng.",
    "settings.themeKicker": "Giao diện",
    "settings.appearanceShell": "Diện mạo shell",
    "settings.priceMarkers": "Price marker",
    "settings.priceMarkersNote": "Bật để hiện marker giá trên nét vẽ đang chọn.",
    "settings.whale": "Lệnh Cá voi",
    "settings.whaleNote": "Hiển thị các lệnh mua/bán lớn trên biểu đồ giá.",
    "settings.whaleThreshold": "Ngưỡng lệnh (VND)",
    "settings.cvd": "CVD (Cumulative Volume Delta)",
    "settings.cvdNote": "Hiển thị chỉ báo CVD trên biểu đồ.",
    "settings.cvdMode": "Chế độ CVD",
    "settings.cvdOscillator": "Oscillator",
    "settings.cvdHistogram": "Histogram",
    "settings.alertAudioEnabled": "Âm thanh cảnh báo",
    "settings.alertAudioEnabledNote": "Phát âm thanh khi có cảnh báo giá được kích hoạt.",
    "settings.resetKicker": "Đặt lại",
    "settings.resetNote": "Đặt lại sẽ khôi phục bố cục khung và tham số chỉ báo mặc định. Giới hạn khung hiển thị có thể được đặt lại từ mục Bố cục.",
    "pane.price": "Giá",
    "pane.volume": "Khối lượng",
    "pane.momentum": "RSI+MACD",
    "pane.orderflow": "Dòng lệnh",
    "pane.strength": "Sức mạnh",
    // ── Indicator Sets ────────────────────────────────────────────────
    "settings.indicatorSets": "Bộ chỉ báo",
    "settings.indicatorSetsTitle": "Quản lý bộ chỉ báo",
    "settings.indicatorSetsKicker": "Bộ chỉ báo",
    "settings.builtinSets": "Mẫu có sẵn",
    "settings.builtinSetsTitle": "Bộ mẫu có sẵn",
    "settings.mySets": "Bộ của tôi",
    "settings.mySetsTitle": "Bộ đã lưu",
    "settings.noUserSets": "Chưa có bộ nào được lưu",
    "settings.saveCurrentSet": "Lưu cấu hình hiện tại",
    "settings.setName": "Tên bộ",
    "settings.setNamePlaceholder": "Đặt tên cho bộ chỉ báo...",
    "settings.defaultSetName": "Bộ chỉ báo mới",
    "settings.importSet": "Nhập từ file",
    "settings.setFileHint": "Hỗ trợ tệp .vnsc-set",
    "settings.setPaneCount": "{count} pane",
    "settings.applySet": "Áp dụng",
    "settings.exportSet": "Xuất",
    "settings.deleteSet": "Xóa",
    "settings.setSaved": "Đã lưu bộ \"{name}\"",
    "settings.setApplied": "Đã áp dụng bộ \"{name}\"",
    "settings.setDeleted": "Đã xóa bộ \"{name}\"",
    "settings.setImported": "Đã nhập bộ \"{name}\"",
    "settings.importError": "Tệp không hợp lệ hoặc không đúng định dạng",
    "indicatorSet.vnSwingSetup": "Bộ VN Swing",
    "indicatorSet.emaMulti": "EMA đa chu kỳ",
    "indicatorSet.orderflowSuite": "Bộ Orderflow",
    "indicatorSet.cryptoStandard": "Bộ Crypto chuẩn",
    "settings.seriesMeta": "{count} chỉ báo · {ratio}%",
    "settings.dataAdapter": "Nguồn dữ liệu",
    "settings.dataAdapterKicker": "Nguồn dữ liệu",
    "settings.dataAdapter.vnstocks": "VNStocks (chưa sẵn sàng)",
    // CE25: Drawings section
    "settings.drawingsKicker": "Nét vẽ",
    "settings.manageDrawings": "Quản lý nét vẽ",
    "settings.syncTimeframes": "Đồng bộ khung thời gian",
    "settings.syncTimeframesNote": "Nét vẽ tạo trên một khung thời gian sẽ hiện trên tất cả khung thời gian cho cùng mã.",
    "settings.visibilityControls": "Điều khiển hiển thị",
    "settings.visibilityControlsNote": "Kiểm soát hiển thị nét vẽ theo khung thời gian và mã.",
    "settings.drawingsSectionNote": "Nét vẽ được lưu theo mã. Sử dụng Cây đối tượng trong Dock nét vẽ để quản lý từng nét vẽ.",
    "settings.enabled": "Bật",
    "settings.disabled": "Tắt",
    // CE25: DrawingListPanel bulk operations
    "drawing.bulkDelete": "Xóa hàng loạt",
    "drawing.bulkGroup": "Nhóm hàng loạt",
    "drawing.bulkLock": "Khóa hàng loạt",
    "drawing.bulkUnlock": "Mở khóa hàng loạt",
    "drawing.bulkHide": "Ẩn hàng loạt",
    "drawing.bulkShow": "Hiện hàng loạt",
    "drawing.groupBy": "Nhóm theo",
    "drawing.groupByType": "Loại",
    "drawing.groupByGroupId": "ID nhóm",
    "drawing.selectAll": "Chọn tất cả",
    "drawing.deselectAll": "Bỏ chọn tất cả",
    "snapshot.preview.title": "Xem trước ảnh chụp",
    "snapshot.preview.save": "Lưu ảnh",
    "snapshot.preview.cancel": "Hủy bỏ",
    // CE29 additions: Templates, Alerts, Pine Editor, Bottom tabs, Strategy Tester
    "ui.template.name": "Nhập tên mẫu giao diện:",
    "ui.template.noTemplates": "Không tìm thấy mẫu giao diện đã lưu",
    "ui.template.select": "Nhập tên mẫu giao diện cần tải:",
    "ui.template.notFound": "Không tìm thấy mẫu giao diện",
    "ui.alert.create": "Tạo cảnh báo",
    "ui.alert.condition": "Điều kiện",
    "ui.alert.crossing": "Cắt qua",
    "ui.alert.crossingUp": "Cắt lên",
    "ui.alert.crossingDown": "Cắt xuống",
    "ui.alert.actions": "Hành động",
    "ui.alert.webhook": "Đường dẫn Webhook URL",
    "ui.bottomTab.strategyTester": "Thử nghiệm chiến thuật",
    "ui.bottomTab.pineEditor": "Trình soạn Pine",
    "ui.bottomTab.paperTrade": "Giao dịch mô phỏng",
    "ui.bottomTab.resizeHandle": "Kéo để thay đổi chiều cao panel",
    "ui.pinescript.editor": "Trình soạn thảo Pine",
    "ui.pinescript.compile": "Lưu và Thêm vào biểu đồ",
    "ui.pinescript.success": "Biên dịch thành công! Đã thêm vào biểu đồ.",
    "ui.pinescript.visuals": "Hình trực quan",
    "ui.pinescript.visuals.bar": "thanh {n}",
    "ui.pinescript.visuals.fillBgcolor": "{n} tô/nền",
    // P0-2 (2026-10-22): script chiến lược được validate bằng engine chiến lược.
    "ui.pinescript.strategyValidated": "Chiến lược đã biên dịch. Chạy thử trong Strategy Tester.",
    "ui.pinescript.strategyNeedsBars": "Chiến lược cần dữ liệu giá để kiểm tra. Hãy mở biểu đồ có dữ liệu rồi biên dịch lại.",
    "ui.pinescript.error": "Lỗi biên dịch",
    "ui.pinescript.export": "Xuất .pine",
    "ui.pinescript.import": "Nhập .pine",
    "ui.pinescript.delete": "Xóa",
    "ui.pinescript.rename": "Đổi tên",
    "ui.pinescript.newScript": "Tập lệnh mới",
    "ui.pinescript.unsaved": "Chưa lưu",
    "ui.pinescript.saving": "Đang lưu...",
    "ui.pinescript.saved": "Đã lưu",
    "ui.pinescript.saveFailed": "Lưu thất bại",
    "ui.pinescript.confirmDelete": "Xóa \"{name}\"?",
    "ui.pinescript.paneLimitReached": "Bá biể đã đạt giới số pane trên biểu đồ. Hãy đóng một pane, hoặc đặt `overlay=true` trong dòng khai báo.",
    "ui.pinescript.alreadyOnChart": "Kịch bản này đã có trên biểu đồ rồi. Hãy sửa nó từ thanh tiên để, hoặc xóa nó trước khi thêm lại.",
    "ui.pinescript.statusCompiled": "Đã biên dịch",
    "ui.pinescript.statusError": "Lỗi",
    "ui.pinescript.statusCompiling": "Đang biên dịch...",
    "ui.pinescript.workerError": "Lỗi worker",
    "ui.pinescript.workerErrorDetail": "Lỗi worker: {message}",
    "ui.pinescript.compileFailed": "Biên dịch thất bại.",
    "ui.pinescript.scriptList": "Tập lệnh",
    "ui.pinescript.inputsTitle": "Tham số",
    "ui.pinescript.resetInputs": "Khôi phục mặc định",
    "ui.pinescript.importSuccess": "Đã nhập \"{name}\"",
    "ui.pinescript.importFailed": "Nhập thất bại: sai định dạng",
    "ui.pinescript.cancel": "Hủy",
    "ui.pinescript.loadingEditor": "Đang tải trình soạn thảo...",
    "ui.indicator.settings.source.price": "Giá",
    "ui.indicator.settings.source.indicators": "Chỉ báo",
    "ui.indicator.settings.source": "Nguồn đầu vào",
    "ui.indicator.settings.timeframe": "Khung thời gian",
    "ui.indicator.settings.timeframe.sameAsChart": "Giống biểu đồ",
    "settings.seriesColor": "Màu sắc",
    "ui.alert.greaterThan": "Lớn hơn",
    "ui.alert.lessThan": "Nhỏ hơn",
    "ui.alert.value": "Giá trị",
    "ui.alert.price": "Giá",
    "ui.alert.indicator": "Chỉ báo",
    "ui.alert.frequency": "Tần suất",
    "ui.alert.once": "Chỉ một lần",
    "ui.alert.oncePerBar": "Một lần mỗi nến",
    "ui.alert.oncePerBarClose": "Một lần khi đóng nến",
    "ui.alert.continuous": "Liên tục",
    "ui.alert.message": "Nội dung cảnh báo",
    "ui.alert.activeAlerts": "Cảnh báo đang hoạt động",
    "ui.alert.noAlerts": "Chưa có cấu hình cảnh báo nào.",
    "ui.alert.delete": "Xóa",
    "ui.alert.reset": "Đặt lại",
    "ui.alert.active": "Hoạt động",
    "ui.alert.deliveryFailed": "Giao webhook thất bại",
    "ui.alert.deliveryFailedAt": "lúc {time}",
    "ui.alert.deliveryNotConfigured": "Chưa cấu hình webhook",
    // ── SaaS Premium Feature Gate ──────────────────────────────────────
    "premium.loading": "Đang kiểm tra quyền truy cập...",
    "premium.invalidToken": "Token không hợp lệ",
    "premium.invalidTokenDesc": "Cần token PAT hợp lệ để sử dụng tính năng này.",
    "premium.isWhalePanelEnabled.title": "Tính năng Whale Flow (Cá mập dòng tiền)",
    "premium.isWhalePanelEnabled.description": "Tính năng này chỉ khả dụng cho gói Pro trở lên.",
    "premium.isReplayEnabled.title": "Tính năng Market Replay (Phát lại thị trường)",
    "premium.isReplayEnabled.description": "Tính năng này chỉ khả dụng cho gói Pro trở lên.",
    // `PremiumFeatureGate.feature` co kieu `keyof SaaSFeatureFlags` nen moi flag deu hop le; thieu key thi lan dung sau se lo raw key ra UI.
    "premium.isAdvisoryEnabled.title": "Tính năng Advisory (Khuyến nghị)",
    "premium.isAdvisoryEnabled.description": "Tính năng này chỉ khả dụng cho gói Pro trở lên.",
    "premium.upgrade": "Nâng cấp ngay",
    "saas.sessionExpired": "Phiên bản đã hết hạn hoặc không có quyền truy cập. Vui lòng tải lại trang.",
    "saas.invalidToken": "Token không hợp lệ hoặc không được hỗ trợ",
    // Ads
    "ads.close": "Đóng",
    "ads.imageAlt": "Quảng cáo VNInvest",
    "ads.title": "Mở Khóa Tính Năng Phân Tích Pro",
    "ads.description": "Bạn đang sử dụng phiên bản miễn phí VNInvestCharts. Nâng cấp tài khoản để truy cập dữ liệu cá mập và giả lập thị trường không giới hạn.",
    "ads.upgrade": "Tìm hiểu Pro",
    "ads.closeCountdown": "Đóng ({countdown}s)",
    // Trademark
    "trademark.tamperDetected": "Phát hiện can thiệp nhãn hiệu",
    "trademark.tamperDescription": "Widget yêu cầu hiển thị nhãn \"Powered by VNInvest\" để hoạt động. Vui lòng khôi phục hiển thị nhãn để tiếp tục sử dụng.",
    "trademark.restore": "Khôi phục và tiếp tục",
    "trademark.ariaLabel": "Powered by VNInvest - Click to visit website",
    // Unified Header (Phase 2 Slice 1)
    "header.symbol.label": "Mã",
    "header.symbol.placeholder": "Tìm kiếm mã...",
    "header.timeframe.label": "Khung thời gian",
    "header.chartType.label": "Loại biểu đồ",
    "header.chartType.options": "Tùy chọn loại biểu đồ",
    "header.sync.groupLabel": "Cài đặt đồng bộ",
    "header.sync.visibleRange": "Khoảng hiển thị",
    "header.sync.crosshair": "Chéo",
    "header.sync.timeframe": "Khung thời gian",
    "header.sync.chartType": "Loại biểu đồ",
    "header.sync.symbolLinks": "Liên kết mã",
    "header.sync.drawings": "Đồ họa",
    "header.sync.replay": "Đồng bộ Replay",
    "header.drawingTools.label": "Công cụ vẽ",
    "header.drawingTools.menuLabel": "Menu công cụ vẽ",
    "header.drawingTools.trendline": "Đường xu hướng",
    "header.drawingTools.hline": "Đường ngang",
    "header.drawingTools.vline": "Đường dọc",
    "header.drawingTools.ray": "Tia",
    "header.drawingTools.fibonacci": "Fibonacci",
    "header.drawingTools.pitchfork": "Pitchfork",
    "header.drawingTools.text": "Văn bản",
    "header.drawingTools.measure": "Đo lường",
    "header.systemMenu.label": "Menu hệ thống",
    // System Menu
    "systemMenu.workspace.title": "Không gian làm việc",
    "systemMenu.workspace.dropdownLabel": "Tùy chọn không gian làm việc",
    "systemMenu.workspace.current": "Đang dùng:",
    "systemMenu.workspace.untitled": "Không gian làm việc chưa đặt tên",
    "systemMenu.workspace.new": "Không gian làm việc mới",
    "systemMenu.workspace.newPlaceholder": "Nhập tên không gian làm việc...",
    "systemMenu.workspace.save": "Lưu",
    "systemMenu.workspace.cancel": "Hủy",
    "systemMenu.workspace.export": "Xuất không gian làm việc",
    "systemMenu.workspace.delete": "Xóa không gian làm việc",
    "systemMenu.workspace.deleteConfirm": "Xóa không gian làm việc này?",
    "systemMenu.workspace.empty": "Chưa có không gian làm việc nào",
    "systemMenu.workspace.import": "Nhập không gian làm việc",
    "systemMenu.layout.title": "Bố cục",
    "systemMenu.layout.dropdownLabel": "Mẫu bố cục",
    "systemMenu.layout.custom": "Tùy chỉnh",
    "systemMenu.layout.designer": "Thiết kế bố cục",
    "systemMenu.sync.title": "Đồng bộ",
    "systemMenu.sync.dropdownLabel": "Cài đặt đồng bộ",
    "systemMenu.export.snapshot": "Xuất ảnh chụp",
    "systemMenu.export.data": "Xuất dữ liệu",
    "systemMenu.theme.title": "Giao diện",
    "systemMenu.theme.modern-light": "Hiện đại Sáng",
    "systemMenu.theme.neutral-pro": "Trung tính Pro",
    "systemMenu.theme.classic-dark": "Cổ điển Tối",
    "systemMenu.theme.trading-night": "Giao dịch Đêm",
    "systemMenu.theme.high-contrast": "Tương phản Cao",
    "systemMenu.settings.title": "Cài đặt",
    "settings.themeStudio.title": "Theme Studio",
    "settings.themeStudio.grid": "Lưới",
    "settings.themeStudio.gridDensity": "Mật độ lưới",
    "settings.themeStudio.crosshair": "Crosshair",
    "settings.themeStudio.candleUp": "Nến tăng",
    "settings.themeStudio.candleDown": "Nến giảm",
    "settings.themeStudio.reset": "Đặt lại",
    // Drawing Tools section (SystemMenu)
    "systemMenu.drawingTools.title": "Công cụ vẽ",
    "systemMenu.drawingTools.dropdownLabel": "Tùy chọn công cụ vẽ",
    "systemMenu.drawingTools.none": "Không có",
    // Context indicator
    "systemMenu.context.workspace": "Chế độ không gian làm việc",
    "systemMenu.context.chart": "Chế độ biểu đồ",
    // Upgrade section
    "systemMenu.upgrade.title": "Nâng cấp Pro",
    "systemMenu.upgrade.desc": "Mở khóa tất cả tính năng",
    // Toolbar extras
    "toolbar.favorites": "Yêu thích",
    "toolbar.undo": "Hoàn tác",
    "toolbar.redo": "Làm lại",
    "toolbar.clearAll": "Xóa tất cả",
    "toolbar.clearAllConfirmTitle": "Xóa tất cả hình vẽ",
    "toolbar.clearAllConfirmMessage": "Xóa {count} hình vẽ? Nhấn Ctrl+Z để hoàn tác sau khi xóa.",
    "toolbar.clearAllConfirm": "Xóa tất cả",
    "toolbar.clearAllDone": "Đã xóa {count} hình vẽ — nhấn Ctrl+Z để hoàn tác",
    "toolbar.cancel": "Hủy",
    // Tier gate (multi-chart layout cap)
    "tierGate.message": "Bố cục này cần {required} biểu đồ (gói của bạn cho phép {max})",
    "tierGate.upgrade": "Nâng cấp",
    "tier.downgrade.message": "Hình vẽ Pro tạm ẩn do thay đổi gói.",
    // S4: magnet shortcut hint
    "toolbar.magnet": "Nam châm",
    // Tool group labels
    "toolbar.group.cursors": "Con trỏ",
    "toolbar.group.trend": "Đường xu hướng",
    "toolbar.group.horizontal": "Ngang & Dọc",
    "toolbar.group.fibonacci": "Fibonacci",
    "toolbar.group.patterns": "Mẫu hình",
    "toolbar.group.shapes": "Hình dạng",
    "toolbar.group.annotations": "Chú thích",
    "toolbar.group.measure": "Đo lường",
    // Chart Types
    "chartType.heikinAshi": "Heikin Ashi",
    "chartType.renko": "Renko",
    "chartType.kagi": "Kagi",
    "chartType.pointAndFigure": "Point & Figure",
    "chartType.lineBreak": "Line Break",
    "chartType.baseline": "Baseline",
    "chartType.proLocked": "Pro", "chartType.comingSoon": "Sắp ra mắt",
    // Keyboard Shortcuts
    "shortcuts.symbolSearch": "Tìm kiếm mã",
    "shortcuts.timeframeNext": "Khung thời gian tiếp theo",
    "shortcuts.timeframePrev": "Khung thời gian trước",
    "shortcuts.chartTypeCycle": "Chuyển loại biểu đồ",
    "shortcuts.toggleSyncVisibleRange": "Bật/tắt đồng bộ khoảng hiển thị",
    "shortcuts.toggleSyncCrosshair": "Bật/tắt đồng bộ chéo",
    "shortcuts.openSystemMenu": "Mở menu hệ thống",
    "shortcuts.toggleDrawingTools": "Bật/tắt công cụ vẽ",
    "shortcuts.undoRedo": "Hoàn tác / Làm lại",
    "shortcuts.removeDrawing": "Xóa hình vẽ đã chọn",
    "shortcuts.copyPaste": "Sao chép / dán hình vẽ",
    "shortcuts.lockHide": "Khóa / ẩn mục đã chọn",
    "shortcuts.cursorCancel": "Công cụ con trỏ / hủy",
    "shortcuts.thisHelp": "Bảng trợ giúp này",
    // P0: các phím ĐANG CHẠY nhưng trước đây không được liệt kê trong help modal.
    "shortcuts.dockToggle": "Bật/tắt dock phải", "shortcuts.syncToggles": "Bật/tắt đồng bộ crosshair / vùng nhìn", "shortcuts.toggleFavorites": "Bật/tắt thanh công cụ yêu thích", "shortcuts.paperTrading": "Giao dịch mô phỏng: mua / bán / đóng", "shortcuts.replay": "Replay: phát–dừng / lùi–tiến", "shortcuts.maximizeCell": "Phóng to ô chart đang chọn",
    // Layout Designer
    "layoutDesigner.title": "Thiết kế bố cục",
    "layoutDesigner.saveAsPreset": "Lưu làm mẫu",
    "layoutDesigner.rows": "Hàng",
    "layoutDesigner.cols": "Cột",
    "layoutDesigner.addRow": "Thêm hàng",
    "layoutDesigner.addCol": "Thêm cột",
    "layoutDesigner.splitHorizontal": "Chia ngang",
    "layoutDesigner.splitVertical": "Chia dọc",
    "layoutDesigner.resizeTop": "Thay đổi kích thước trên",
    "layoutDesigner.resizeRight": "Thay đổi kích thước phải",
    "layoutDesigner.resizeBottom": "Thay đổi kích thước dưới",
    "layoutDesigner.resizeLeft": "Thay đổi kích thước trái",
    "layoutDesigner.savePresetTitle": "Lưu làm mẫu",
    "layoutDesigner.presetNamePlaceholder": "Nhập tên mẫu",
    "layoutDesigner.savePresetFailed": "Không lưu được mẫu bố cục. Vui lòng thử lại.",
    "layoutDesigner.savedPresets": "Mẫu đã lưu",
    "layoutDesigner.deletePreset": "Xoá mẫu",
    // Presets
    "presets.1x1": "1x1",
    "presets.1x2": "1x2",
    "presets.2x1": "2x1",
    "presets.2x2": "2x2",
    "presets.1x4": "1x4",
    "presets.4x1": "4x1",
    "presets.2x4": "2x4",
    "presets.lShape": "Hình L",
    "presets.lShapeDesc": "Biểu đồ chính lớn với hai biểu đồ chồng lên nhau ở bên",
    "presets.tShape": "Hình T",
    "presets.tShapeDesc": "Biểu đồ chính rộng với ba biểu đồ bên dưới",
    "presets.main3Sidebar": "Chính + 3 Thanh bên",
    "presets.main3SidebarDesc": "Biểu đồ chính cao với ba biểu đồ thanh bên",
    "presets.quadFocus": "Bốn + Tập trung",
    "presets.quadFocusDesc": "Biểu đồ tập trung lớn với bốn biểu đồ nhỏ xung quanh",
    // Conflict Resolver
    "conflictResolver.title": "Xung đột vẽ",
    "conflictResolver.concurrentEdit": "Phát hiện chỉnh sửa đồng thời",
    "conflictResolver.deleteVsEdit": "Một người xóa trong khi người khác chỉnh sửa",
    "conflictResolver.moveVsEdit": "Điểm được di chuyển trong khi bản vẽ được chỉnh sửa",
    "conflictResolver.unknown": "Xung đột không xác định",
    "conflictResolver.noVersionDiff": "Không có khác biệt phiên bản",
    "conflictResolver.details": "Chi tiết xung đột",
    "conflictResolver.localVersion": "Phiên bản cục bộ",
    "conflictResolver.remoteVersion": "Phiên bản từ xa",
    "conflictResolver.keepLocal": "Giữ cục bộ",
    "conflictResolver.keepRemote": "Giữ từ xa",
    "conflictResolver.merge": "Hợp nhất",
    "conflictResolver.dismiss": "Bỏ qua",
    // ── Mobile Layout ────────────────────────────────────────────────
    "mobile.timeframe": "Khung thời gian",
    "mobile.chartType": "Loại biểu đồ",
    "mobile.compare": "So sánh",
    "mobile.closeCompare": "Đóng so sánh",
    "mobile.replay": "Phát lại",
    "mobile.pauseReplay": "Tạm dừng",
    "mobile.selectChart": "Chọn biểu đồ",
    "mobile.drawingTools": "Công cụ vẽ",
    "mobile.layout": "Bố cục lưới",
    "mobile.sync": "Đồng bộ",
    "mobile.syncVisibleRange": "Đồng bộ khoảng nến",
    "mobile.syncCrosshair": "Đồng bộ Crosshair",
    "mobile.syncDrawings": "Đồng bộ hình vẽ",
    "mobile.syncSymbolLinks": "Đồng bộ liên kết mã",
    "mobile.syncTimeframe": "Đồng bộ khung thời gian",
    "mobile.syncChartType": "Đồng bộ loại biểu đồ",
    "mobile.syncReplay": "Đồng bộ Replay",
    "mobile.syncTime": "Đồng bộ thời điểm (giữ zoom)",
    "mobile.features": "Tính năng",
    "mobile.pineEditor": "Trình soạn Pine",
    "mobile.strategyTester": "Thử nghiệm",
    "mobile.chartActions": "Tác vụ biểu đồ",
    "mobile.addChart": "Thêm biểu đồ",
    "mobile.saveWorkspace": "Lưu workspace",
    "topbar.layoutTitle": "Bố cục biểu đồ",
    "topbar.noChartHint": "Chọn một ô biểu đồ để cấu hình mã/timeframe",
    "topbar.focusedChart": "Đang chọn: {symbol} (Chart {index})",
    "legend.show": "Hiện",
    "legend.hide": "Ẩn",
    "legend.remove": "Xóa khỏi pane",
    "legend.edit": "Cài đặt indicator",
    "footer.scale.group": "Thang giá",
    "footer.scale.auto": "Tự động",
    "footer.scale.log": "Log",
    "footer.scale.percent": "%",
    "footer.timezone": "Múi giờ",
    "footer.countdown": "Đếm ngược nến",
    "footer.timeframeGroup": "Khung nến",
    "footer.rangeGroup": "Phạm vi",
    "footer.resetLayout": "Mặc định",
    "footer.resetConfirm": "Khôi phục bố cục mặc định (chỉ Nến & Khối lượng)?",
    "datawindow.symbol": "Mã",
    "datawindow.time": "Thời gian",
    "datawindow.open": "Mở",
    "datawindow.high": "Cao",
    "datawindow.low": "Thấp",
    "datawindow.close": "Đóng",
    "datawindow.volume": "Khối lượng",
    "datawindow.change": "Thay đổi",
    "drawingTool.cursor": "Con trỏ",
    "drawingTool.crosshair": "Tâm chữ thập",
    "drawingTool.trendLine": "Đường xu hướng",
    "drawingTool.ray": "Tia",
    "drawingTool.extendedLine": "Đường kéo dài",
    "drawingTool.parallelChannel": "Kênh song song",
    "drawingTool.hLine": "Đường nằm ngang",
    "drawingTool.vLine": "Đường thẳng đứng",
    "drawingTool.priceLine": "Đường mức giá",
    // Xem messages.en.ts: id là tool id chuẩn; thiếu key sẽ lộ raw key ra UI.
    "drawingTool.priceLabel": "Nhãn giá",
    "drawingTool.fibExtension": "Fib mở rộng",
    "drawingTool.fibChannel": "Kênh Fibonacci",
    "drawingTool.fibTimeZone": "Múi giờ Fibonacci",
    "drawingTool.dateAndPriceRange": "Khoảng ngày và giá",
    "drawingTool.fibonacci": "Fib thoái lui",
    "drawingTool.fibonacciExtension": "Fib mở rộng",
    "drawingTool.fibonacciChannel": "Kênh Fibonacci",
    "drawingTool.fibonacciTime": "Múi giờ Fibonacci",
    "drawingTool.pitchfork": "Pitchfork",
    "drawingTool.schiffPitchfork": "Schiff Pitchfork",
    "drawingTool.gannBox": "Hộp Gann",
    "drawingTool.gannFan": "Quạt Gann",
    "drawingTool.brush": "Bút vẽ",
    "drawingTool.rectangle": "Hình chữ nhật",
    "drawingTool.ellipse": "Hình elip",
    "drawingTool.triangle": "Hình tam giác",
    "drawingTool.arc": "Vòng cung",
    "drawingTool.text": "Văn bản",
    "drawingTool.callout": "Chú thích",
    "drawingTool.arrow": "Mũi tên",
    "drawingTool.measure": "Thước đo",
    "drawingTool.dateRange": "Khoảng ngày",
    "drawingTool.priceRange": "Khoảng giá",
    "drawingTool.eraser": "Cục tẩy",
    "drawingTool.polygon": "Đa giác",
    "drawingTool.longPosition": "Lệnh Long",
    "drawingTool.shortPosition": "Lệnh Short",
    "drawingTool.toggleMagnet": "Bật/tắt magnet",
    "grid.splitter.resizeRow": "Thay đổi kích thước hàng {row}",
    "grid.splitter.resizeColumn": "Thay đổi kích thước cột {column}",
    "grid.splitter.resetTracks": "Nhấp đúp để đặt lại kích thước",
    "grid.splitter.valuePercent": "{percent}%",
    "pane.splitter.tooltip": "Kéo để chỉnh pane • Nhấn đúp để cân bằng",
    "pane.splitter.ariaLabel": "Thanh chia pane, hàng {index}",
    "pane.splitter.badgeTop": "Trên",
    "pane.splitter.badgeBottom": "Dưới",
    "crosshair.mode.label": "Chế độ crosshair",
    "crosshair.mode.crossTitle": "Crosshair chữ thập",
    "crosshair.mode.dotTitle": "Crosshair chấm (chỉ hiện giá trị)",
    "crosshair.mode.magnetTitle": "Crosshair nam châm (bám OHLC)",
    "priceScale.menuTitle": "Trục giá",
    "priceScale.auto": "Tự động",
    "priceScale.log": "Logarit",
    "priceScale.percent": "Phần trăm",
    "priceScale.resetZoom": "Đặt lại zoom giá",
    "priceScale.logUnavailable": "Thang log cần giá dương",
    "scrollbar.windowLabel": "Thanh điều hướng vùng hiển thị",
    "scrollbar.valuePercent": "Hiển thị {percent}%",
    "statusLine.collapse": "Thu gọn dòng trạng thái",
    "statusLine.expand": "Mở rộng dòng trạng thái",
    "statusLine.hideSeries": "Ẩn chuỗi dữ liệu",
    "statusLine.showSeries": "Hiện chuỗi dữ liệu",
    "statusLine.settings": "Cài đặt",
    "statusLine.remove": "Xóa",
    "statusLine.countdown": "Đếm ngược nến",
    // ── Chart Settings Tabs & Controls ──────────────────────────────
    "settings.title": "Cài đặt biểu đồ",
    "settings.searchPlaceholder": "Tìm kiếm cài đặt...",
    "settings.restoreDefaults": "Khôi phục mặc định",
    "settings.cancel": "Hủy bỏ",
    "settings.apply": "Đồng ý",
    "settings.tab.symbol": "Mã & Nến",
    "settings.tab.statusLine": "Dòng trạng thái",
    "settings.tab.scales": "Thang đo & Toạ độ",
    "settings.tab.appearance": "Diện mạo & Nền",
    "settings.tab.panes": "Bố cục & Khung",
    "settings.tab.indicators": "Chỉ báo",
    "settings.tab.trading": "Giao dịch & Sự kiện",
    "settings.tab.theme": "Chủ đề & Màu sắc",
    "settings.tab.licensing": "Bản quyền SaaS",
    "settings.tab.reset": "Khôi phục",
    "settings.symbol.candleStyle": "Kiểu biểu đồ",
    "settings.symbol.chartStyle": "Kiểu biểu đồ",
    "settings.symbol.style": "Kiểu hiển thị",
    "settings.styleBar": "Thanh (Bar)",
    "settings.styleLine": "Đường (Line)",
    "settings.symbol.colors": "Màu sắc nến",
    "settings.symbol.body": "Thân nến",
    "settings.symbol.borders": "Viền nến",
    "settings.symbol.wick": "Bấc nến",
    "settings.symbol.up": "Tăng",
    "settings.symbol.down": "Giảm",
    "settings.symbol.upColor": "Màu nến tăng",
    "settings.symbol.downColor": "Màu nến giảm",
    "settings.symbol.priceLines": "Đường giá tham chiếu",
    "settings.symbol.lastPriceLine": "Đường giá gần nhất",
    "settings.symbol.prevClosePriceLine": "Đường giá đóng cửa phiên trước",
    "settings.symbol.highLowPriceLines": "Đường giá cao nhất/thấp nhất",
    "settings.symbol.general": "Cấu hình chung",
    "settings.symbol.precision": "Độ chính xác số thập phân",
    "settings.symbol.precision.default": "Mặc định theo mã",
    "settings.symbol.timezone": "Múi giờ giao dịch",
    "settings.statusLine.symbol": "Thông tin mã cổ phiếu",
    "settings.statusLine.logo": "Logo biểu đồ",
    "settings.statusLine.showLogo": "Hiển thị Logo doanh nghiệp",
    "settings.statusLine.ticker": "Mã cổ phiếu",
    "settings.statusLine.showTicker": "Hiển thị Mã cổ phiếu (Ticker)",
    "settings.statusLine.ohlc": "Giá trị OHLC",
    "settings.statusLine.showOhlc": "Hiển thị cụm giá OHLC (Mở, Cao, Thấp, Đóng)",
    "settings.statusLine.barChange": "Biến động thanh nến",
    "settings.statusLine.showBarChange": "Hiển thị biến động thanh nến (Điểm số & %)",
    "settings.statusLine.volume": "Khối lượng",
    "settings.statusLine.showVolume": "Hiển thị Khối lượng giao dịch",
    "settings.statusLine.indicators": "Chỉ báo trên dòng trạng thái",
    "settings.statusLine.indicatorTitles": "Tên chỉ báo",
    "settings.statusLine.showIndicatorTitles": "Hiển thị Tên các chỉ báo",
    "settings.statusLine.indicatorArguments": "Tham số chỉ báo",
    "settings.statusLine.showIndicatorArguments": "Hiển thị Tham số cấu hình",
    "settings.statusLine.indicatorValues": "Giá trị chỉ báo",
    "settings.statusLine.showIndicatorValues": "Hiển thị Giá trị thời gian thực",
    "settings.statusLine.appearance": "Giao diện thanh trạng thái",
    "settings.statusLine.bgOpacity": "Độ mờ nền",
    "settings.statusLine.backgroundOpacity": "Độ mờ nền thanh trạng thái",
    "settings.scales.priceScale": "Thang đo giá (Trục Y)",
    "settings.scales.priceScaleMode": "Chế độ thang đo",
    "settings.scales.mode": "Chế độ thang đo",
    "settings.scales.mode.normal": "Thông thường (Linear)",
    "settings.scales.mode.log": "Logarit (Log)",
    "settings.scales.mode.percentage": "Phần trăm (%)",
    "settings.scales.normal": "Thông thường",
    "settings.scales.logarithmic": "Logarit",
    "settings.scales.percentage": "Phần trăm",
    "settings.scales.invertScale": "Đảo ngược thang đo",
    "settings.scales.axisPosition": "Vị trí trục giá",
    "settings.scales.right": "Bên phải",
    "settings.scales.left": "Bên trái",
    "settings.scales.labels": "Nhãn giá trị trên trục",
    "settings.scales.showSymbolLastValue": "Nhãn giá trị gần nhất của mã",
    "settings.scales.showPrevCloseValue": "Nhãn giá đóng cửa phiên trước",
    "settings.scales.showIndicatorValues": "Nhãn giá trị của các chỉ báo",
    "settings.scales.countdown": "Đếm ngược đóng nến",
    "settings.scales.showCountdown": "Hiển thị đồng hồ đếm ngược đóng nến",
    "settings.scales.timeAxis": "Trục thời gian (Trục X)",
    "settings.scales.timeScrollbar": "Thanh cuộn thời gian",
    "settings.scales.showScrollbar": "Thanh điều hướng thời gian (Scrollbar)",
    "settings.scales.showScrollbarNote": "Hiển thị thanh trượt/slice điều hướng vùng hiển thị nằm dưới trục X",
    "settings.scales.dateFormat": "Định dạng ngày",
    "settings.scales.timeFormat": "Định dạng giờ",
    "settings.appearance.background": "Màu nền",
    "settings.appearance.bgType": "Kiểu nền",
    "settings.appearance.solid": "Màu đơn (Solid)",
    "settings.appearance.gradient": "Màu chuyển (Gradient)",
    "settings.appearance.bgColor": "Màu nền",
    "settings.appearance.gradientColors": "Màu gradient (Trên / Dưới)",
    "settings.appearance.grid": "Đường lưới",
    "settings.appearance.vertGrid": "Lưới dọc",
    "settings.appearance.horzGrid": "Lưới ngang",
    "settings.appearance.crosshair": "Đường dấu cộng (Crosshair)",
    "settings.appearance.crosshairMode": "Kiểu crosshair",
    "settings.appearance.crosshairColor": "Màu crosshair",
    "settings.appearance.watermark": "Hình mờ mã cổ phiếu (Watermark)",
    "settings.appearance.watermarkAndFont": "Watermark & Cỡ chữ toạ độ",
    "settings.appearance.showWatermark": "Hiển thị hình mờ mã cổ phiếu",
    "settings.appearance.scalesFont": "Cỡ chữ trục toạ độ",
    "settings.appearance.scalesFontSize": "Cỡ chữ trục toạ độ",
    "settings.panes.maxPanes": "Số lượng Pane tối đa",
    "settings.panes.showNonTrading": "Hiển thị ngày không giao dịch",
    "settings.overlay": "Lớp phủ đa khung thời gian (MTF)",
    "settings.panes.overlayTimeframe": "Khung thời gian phủ",
    "settings.panes.overlayStyle": "Kiểu hiển thị nến phủ",
    "settings.paneNamePlaceholder": "Tên Pane...",
    "settings.workspaceJsonDesc": "Xuất hoặc nhập toàn bộ cấu hình làm việc bao gồm các pane và chỉ báo",
    "settings.panes.exportWorkspace": "Xuất JSON",
    "settings.panes.importWorkspace": "Nhập JSON",
    "settings.indicatorsCount": "chỉ báo",
    "settings.noIndicatorsInPane": "Chưa có chỉ báo trong pane này. Thêm chỉ báo bên dưới.",
    "settings.addSeries": "+ Thêm chỉ báo",
    "settings.builtin": "Mặc định",
    "settings.custom": "Tuỳ chỉnh",
    "common.save": "Lưu",
    "settings.priceClose": "Giá đóng cửa (Close)",
    "settings.priceOpen": "Giá mở cửa (Open)",
    "settings.priceHigh": "Giá cao nhất (High)",
    "settings.priceLow": "Giá thấp nhất (Low)",
    "settings.priceVolume": "Khối lượng (Volume)",
    "settings.lineWidth": "Độ dày nét vẽ",
    "settings.trading.corporateEvents": "Sự kiện doanh nghiệp",
    "settings.trading.showCorporateEvents": "Hiển thị sự kiện doanh nghiệp trên biểu đồ",
    "settings.trading.showCorporateEventsNote": "Đánh dấu sự kiện chia cổ tức (D) và thưởng cổ phiếu (S) trên nến",
    "settings.trading.whaleFlow": "Dòng tiền cá mập (Whale Flow)",
    "settings.trading.enableWhale": "Bật phát hiện dòng tiền lớn",
    "settings.trading.enableWhaleNote": "Làm nổi bật các lệnh có khối lượng đột biến",
    "settings.trading.whaleThreshold": "Ngưỡng giao dịch cá mập (VND)",
    "settings.trading.cvd": "Delta khối lượng tích lũy (CVD)",
    "settings.trading.enableCVD": "Hiển thị chỉ báo CVD",
    "settings.trading.cvdMode": "Chế độ hiển thị CVD",
    "settings.trading.cvdOscillator": "Dao động (Oscillator)",
    "settings.trading.cvdHistogram": "Cột (Histogram)",
    "settings.trading.alertsAndPaper": "Cảnh báo & Giao dịch mô phỏng",
    "settings.trading.alertAudio": "Bật chuông âm thanh khi kích hoạt cảnh báo giá",
    "settings.trading.alertChime": "Âm thanh cảnh báo",
    "settings.trading.showPaperOrders": "Hiển thị các đường lệnh chờ giao dịch mô phỏng trên biểu đồ",
    "settings.trading.showPaperPositions": "Hiển thị vị thế mở và đường Cắt lỗ/Chốt lời",
    "settings.trading.paperMarkers": "Hiển thị vị thế giao dịch mô phỏng",
    "settings.trading.dataSource": "Nguồn cung cấp dữ liệu",
    "settings.theme.mode": "Chế độ hiển thị (Theme Mode)",
    "settings.theme.activeMode": "Chế độ hiện tại",
    "settings.theme.dark": "Tối (Dark)",
    "settings.theme.light": "Sáng (Light)",
    "settings.theme.presets": "Mẫu giao diện sẵn có (Theme Presets)",
    "settings.theme.palette": "Bảng màu nến nổi bật",
    "settings.theme.restoreTheme": "Đặt lại màu theme",
    "widget.trading.buy": "Mua",
    "widget.trading.sell": "Bán",
    "widget.trading.market": "Thị trường",
    "widget.trading.limit": "Giới hạn",
    "widget.trading.stop": "Dừng",
    "widget.trading.quantity": "Khối lượng",
    "widget.trading.price": "Giá",
    "widget.trading.stopPrice": "Giá dừng",
    "widget.trading.takeProfit": "Chốt lời",
    "widget.trading.stopLoss": "Cắt lỗ",
    "widget.trading.trailingDelta": "Dời bám (ticks)",
    "widget.trading.timeInForce": "Hiệu lực lệnh",
    "widget.trading.gtc": "GTC",
    "widget.trading.buyingPower": "Sức mua",
    "widget.trading.requiredMargin": "Ký quỹ yêu cầu",
    "widget.trading.riskReward": "Tỷ lệ R:R",
    "widget.trading.estProfit": "Lãi dự kiến",
    "widget.trading.estLoss": "Lỗ dự kiến",
    "widget.trading.accountRisk": "Rủi ro tài khoản",
    "widget.trading.oneClick": "Một chạm",
    "widget.trading.syntheticQuoteHint": "Giá Bid/Ask mô phỏng từ nến (không phải sổ lệnh thật)",
    "widget.trading.orderTicket": "Phiếu đặt lệnh",
    "widget.trading.placeOrder": "Đặt lệnh",
    "widget.trading.cancel": "Hủy",
    "widget.trading.close": "Đóng",
    "widget.trading.lots": "lô",
    "widget.trading.contracts": "HĐ",
    "widget.trading.ticketBuyTitle": "Mua {symbol}",
    "widget.trading.ticketSellTitle": "Bán {symbol}",
    "widget.trading.insufficientBuyingPower": "Sức mua không đủ",
    "widget.trading.invalidQuantity": "Khối lượng không hợp lệ",
    "widget.trading.shortNotAllowed": "Không được bán khống",
    "widget.trading.noQuote": "Chưa có giá",
    "widget.trading.confirmCloseTitle": "Đóng nhanh vị thế",
    "widget.trading.confirmCloseMessage": "Đóng {quantity} {symbol} tại giá thị trường?",
    "widget.trading.confirm": "Xác nhận",
    "widget.trading.long": "Long",
    "widget.trading.short": "Short",
    "widget.trading.closePosition": "Đóng vị thế",
    "widget.trading.closeAllPositions": "Đóng tất cả vị thế",
    "widget.trading.reversePosition": "Đảo chiều",
    "widget.trading.cancelOrder": "Hủy lệnh",
    "widget.trading.newPrice": "Giá mới",
    "widget.trading.positions": "Vị thế",
    "widget.trading.orders": "Lệnh chờ",
    "widget.trading.history": "Lịch sử",
    "widget.trading.summary": "Tổng quan",
    "widget.trading.log": "Nhật ký",
    "widget.trading.symbol": "Mã",
    "widget.trading.side": "Chiều",
    "widget.trading.entryPrice": "Giá vào",
    "widget.trading.markPrice": "Giá hiện tại",
    "widget.trading.availability": "Trạng thái",
    "widget.trading.available": "Khả dụng",
    "widget.trading.awaitingSettlement": "Chờ về (T+2)",
    "widget.trading.orderType": "Loại lệnh",
    "widget.trading.orderPrice": "Giá đặt",
    "widget.trading.triggerPrice": "Giá kích hoạt",
    "widget.trading.orderTime": "Thời gian đặt",
    "widget.trading.fillPrice": "Giá khớp",
    "widget.trading.commission": "Phí",
    "widget.trading.tax": "Thuế",
    "widget.trading.exitReason": "Lý do thoát",
    "widget.trading.time": "Thời gian",
    "widget.trading.totalTrades": "Tổng số lệnh",
    "widget.trading.winRate": "Tỷ lệ thắng",
    "widget.trading.profitFactor": "Hệ số lợi nhuận",
    "widget.trading.netProfit": "Lợi nhuận ròng",
    "widget.trading.maxDrawdown": "Lỗ tối đa",
    "widget.trading.balance": "Tiền mặt",
    "widget.trading.equity": "Tài sản",
    "widget.trading.unrealizedPnl": "PnL mở",
    "widget.trading.marginLevel": "Mức ký quỹ",
    "widget.trading.reset": "Đặt lại",
    "widget.trading.closePanel": "Đóng panel",
    "widget.trading.paperTrading": "Giao dịch mô phỏng",
    "widget.trading.reverse": "Đảo",
    "widget.trading.noPositions": "Chưa có vị thế mở",
    "widget.trading.emptyPositionsHint": "Đặt lệnh trực tiếp trên biểu đồ hoặc nhấn Shift + B để mở phiếu lệnh",
    "widget.trading.marginSafe": "An toàn",
    "widget.trading.marginWarning": "Cảnh báo",
    "widget.trading.marginDanger": "Nguy hiểm",
    "widget.trading.refillTitle": "Nạp vốn paper",
    "widget.trading.refillMessage": "Đặt lại tài khoản về đúng số vốn bạn nhập.",
    "widget.trading.refillAmount": "Số vốn",
    "widget.trading.refillInvalid": "Nhập số tiền từ 1 đến 1.000.000.000.000",
    "widget.trading.paperVisibilityActive": "Hiển thị giao dịch mô phỏng trên",
    "widget.trading.paperVisibilityActiveNote": "Chỉ áp dụng cho biểu đồ đang chọn",
    "widget.trading.noOrders": "Không có lệnh chờ",
    "widget.trading.noHistory": "Chưa có lịch sử khớp",
    "widget.trading.resetConfirmTitle": "Đặt lại tài khoản?",
    "widget.trading.resetConfirmMessage": "Xóa toàn bộ vị thế, lệnh và lịch sử, về số dư ban đầu?",
    "ui.bottomTab.paperTrading": "Giao dịch mô phỏng",
    "widget.trading.save": "Lưu",
    "widget.trading.editOrder": "Sửa lệnh",
    "widget.trading.orderHistory": "Lệnh đã đặt",
    "widget.trading.tradeHistory": "Giao dịch đã khớp",
    "widget.trading.noTrades": "Chưa có vị thế đã đóng",
    "widget.trading.orderStatus": "Trạng thái",
    "widget.trading.statusFilled": "Đã khớp",
    "widget.trading.statusCancelled": "Đã hủy",
    "widget.trading.statusRejected": "Bị từ chối",
    "widget.trading.spread": "Chênh lệch",
    "widget.trading.enablePaperTrading": "Bật giao dịch mô phỏng",
    "widget.trading.paperTradingOff": "Giao dịch mô phỏng đã tắt",
    "widget.trading.paperTradingOffHint": "Bật để xem giá, đặt lệnh và kéo SL/TP trên chart",
    "widget.trading.dragToMove": "Kéo để di chuyển",
    "widget.trading.resetPosition": "Nhấp đúp để đặt lại vị trí",
    "widget.trading.realizedPnl": "Lãi/lỗ đã chốt",
    "widget.trading.accountMargin": "Ký quỹ tài khoản",
    "widget.trading.availableFunds": "Tiền khả dụng",
    "widget.trading.ordersMargin": "Ký quỹ lệnh chờ",
    "widget.trading.sharpeRatio": "Tỷ số Sharpe",
    "widget.trading.exportCsv": "Xuất CSV",
    "widget.trading.exitUnit": "Đơn vị TP/SL",
    "widget.trading.unitPrice": "Giá",
    "widget.trading.unitTicks": "Ticks",
    "widget.trading.unitPercent": "% vốn",
    "widget.trading.offsetFromMark": "Lệch so với giá TT (ticks)",
    "widget.trading.paperVisibility": "Hiển thị giao dịch mô phỏng",
    "widget.trading.paperMaster": "Bật cho toàn workspace",
    "widget.trading.paperPerChart": "Ghi đè riêng từng ô chart bên dưới",
    "widget.trading.hidePaperTrading": "Ẩn giao dịch mô phỏng (bật lại trong Cài đặt)",
    "widget.trading.showPaperTrading": "Hiện giao dịch mô phỏng",
    "toast.dismiss": "Bỏ qua thông báo",
    "error.retry": "Thử lại",
    "error.reload": "Tải lại biểu đồ",
    "error.dataFetch": "Không tải được dữ liệu thị trường. Kiểm tra kết nối và thử lại.",
    "error.timeout": "Yêu cầu dữ liệu quá thời gian. Thử lại sau ít phút.",
    "error.unknown": "Đã có lỗi xảy ra. Thử lại hoặc tải lại biểu đồ.",
    "shortcuts.title": "Phím tắt",
    "shortcuts.hint": "Nhấn ? bất cứ lúc nào để mở lại bảng này.",
    // Namespace tách riêng: mỗi file có ngưỡng fat-file riêng; catalog này đã ở trần nên không được thêm key trực tiếp (L-P01).
    ...dockMessagesVi, ...pricePaneMessagesVi, ...tradingMessagesVi,
    ...a11yMessagesVi, ...licensingMessagesVi, ...capabilityMessagesVi, ...settingsMessagesVi, ...strategyMessagesVi,
};
